<template>
    <div class="home">
        <Header ref="header" :type='headType'></Header>
        <div class="banner">
            <div class="bannerBox pc-banner swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="item in banList" :key="item.banImg" >
                        <div class="banImg imgBg" :style="{'background-image': 'url('+item.image+')'}">
                            <a v-if="item.go_url" :href='item.go_url'></a>
                        </div>
                        <!-- <div class="banText flex-center text-center">
                            <div class="wrap">
                                <div class="banTit f72" data-swiper-parallax="-40%">{{item.title}}</div>
                                <div class="banCon f48" data-swiper-parallax="-25%">
                                    <p>快捷  丨  准时  丨  安全  丨  优质</p>
                                </div>
                            </div>
                        </div> -->
                    </div>

                </div>
                <div class="swiper-pagination ban-pagination"></div>
            </div>
        </div>
        <div class="mainBg">
            <div class="hm2Bg">
                <div class="wrap">
                    <div class="hmTit text-center wow fadeInUp">
                        <h2 class="hmTitCn f40 color0">关于我们</h2>
                        <div class="hmTitDes f20 color6">
                            <p>提供仓储、装卸、简单包装、配送、库存管理、信息处理、咨询等“一站式”综合物流服务</p>
                        </div>
                    </div>
                    <div class="hm2Top flex align-center justify-between">
                        <div class="hm2Img wow fadeInLeft">
                            <img :src="hm2Info.image" alt="">
                        </div>
                        <div class="hm2Text">
                            <h3 class="hm2Tit f30 color3">{{hm2Info.title}}</h3>
                            <div class="hm2Con f18 color6 MultiLine wow fadeInUp">
                                <div class="hm2des" v-html="hm2Info.content">
                                </div>
                            </div>
                            <a class="hm2More f18 color_m" href="/about">MORE</a>
                        </div>
                    </div>
                    <ul class="hm2List list-style flex justify-between f18 color6 text-center">
                        <li class="wow fadeInLeft" data-wow-delay="0.1s">
                            <div class="hm2Item f18 color_m">
                                <strong class="f60">{{hm2Info.establishment_time}}</strong>
                                <span>年</span>
                            </div>
                            <p>成立于</p>
                        </li>
                        <li class="wow fadeInLeft" data-wow-delay="0.2s">
                            <div class="hm2Item f18 color_m">
                                <strong class="f60">{{hm2Info.division}}</strong>
                                <span>个</span>
                            </div>
                            <p>事业部</p>
                        </li>
                        <li class="wow fadeInLeft" data-wow-delay="0.3s">
                            <div class="hm2Item f18 color_m">
                                <strong class="f60">{{hm2Info.warehouse_area}}</strong>
                                <span>万平方米</span>
                            </div>
                            <p>仓储面积超过</p>
                        </li>
                        <li class="wow fadeInLeft" data-wow-delay="0.4s">
                            <div class="hm2Item f18 color_m">
                                <strong class="f60">{{hm2Info.staff}}</strong>
                                <span>余人</span>
                            </div>
                            <p>员工</p>
                        </li>
                        <li class="wow fadeInLeft" data-wow-delay="0.4s">
                            <div class="hm2Item f18 color_m">
                                <strong class="f60">{{hm2Info.vehicle}}</strong>
                                <span>辆+</span>
                            </div>
                            <p>流动车辆</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="hm3Bg">
                <div class="hm3Box wow fadeIn">
                    <div class="hm3Swiper color_f">
                        <div class="swiper-container">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide" v-for="item in hm3List" :key="item.id">
                                    <div class="hmBox hm3Item">
                                        <div class="hm3Img">
                                            <img :src="item.image" alt="">
                                        </div>
                                        <div class="hm3Con color_f">
                                            <div class="hm3Ico flex-center">
                                                <img :src="item.small_icons" alt="">
                                            </div>
                                            <h3 class="hm3Tit f40 text-center">{{item.title}}</h3>
                                            <div class="hm3Text f18 MultiLine">
                                                <div class="hm3Des">
                                                    <p v-for="(a, i) in item.content_data" :key="i">{{ a.value_1 }}</p>
                                                </div>
                                            </div>
                                            <router-link class="hmMore hm3More white f18" :to="'servicedetail?id=' + item.id">了解详情 +</router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="hm-pagination"></div>
                    </div>
                </div>
            </div>
            <div class="hm4Bg">
                <div class="wrap">
                    <div class="hmTit text-center wow fadeInUp">
                        <h2 class="hmTitCn f40 color0">经典案例</h2>
                        <div class="hmTitDes f20 color6">
                            <p>十六家分公司分布在北京各城区，具有丰富的业内经验和行业资源</p>
                        </div>
                    </div>
                    <ul class="hm4List list-style">
                        <li :class="'hm4Li' + (index + 1) + ' wow fadeInUp'" :data-wow-delay="index/5 + 's'" v-for="(item, index) in hm4List" :key="index">
                            <router-link class="hm4Link baseLink" :to="'/caseDetail?id=' + item.id">
                                <div class="hm4Img baseImg">
                                    <img :src="item.image" alt="">
                                </div>
                                <!-- <div class="hm4Logo">
                                    <img src="@/assets/images/index/box4-logo1.png" alt="">
                                </div> -->
                                <h3 class="hm4Tit f24 color_f text-center ellipsis">{{item.title}}</h3>
                            </router-link>
                        </li>
                    </ul>
                    <router-link class="hmMore hm4More f18 wow fadeInUp" :to="{ path: '/case' }">查看更多 +</router-link>
                </div>
            </div>
            <div class="hm5Bg">
                <div class="wrap">
                    <div class="hm5Box flex" ref="hm5Box">
                        <div class="hm5Left">
                            <div class="hmTit wow fadeInDown">
                                <h2 class="hmTitCn f40 color0">新闻资讯</h2>
                                <div class="hmTitDes f20 color6">
                                    <p>关注我们，掌握最新动态！</p>
                                </div>
                            </div>
                            <ul class="hm5Tab list-style f24 color3 wow fadeInUp">
                                <!-- <li :class=" hm5Index == index ? 'active' : '' " v-for="(item, index) in hm5Tab" :key="index" @click="changeHm5(index)"><span>{{item.text}}</span></li> -->
                                <li v-for="(item, index) in hm5Tab" :key="index" :class="hm5Index == item[0] ? 'active' : '' "><span @click="changeHm5(index)">{{ item[1] }}</span></li>
                            </ul>
                        </div>
                        <div class="hm5Right">
                            <div class="hm5Swiper hm5Swiper1" :style="'width:calc(100% + '+hm5Lef+'px)'">
                                <div class="swiper-container">
                                    <div class="swiper-wrapper">
                                        <div class="swiper-slide" v-for="(item, index) in hm5List" :key="index">
                                            <router-link class="hm5Link baseLink" :to="'/newsDetail?id=' + item.id">
                                                <div class="time f72 color9">{{item.article_date.substring(8,10)}}</div>
                                                <div class="date f16 color3">{{item.article_date.substring(0,7)}}</div>
                                                <h3 class="hm5Tit f18 color3 MultiLine">{{item.title}}</h3>
                                                <div class="hm5Img">
                                                    <img :src="item.image" alt="">
                                                </div>
                                                <div class="hm5Con f18 color6 MultiLine">
                                                    <div class="hm5Des" v-html="item.content"></div>
                                                </div>
                                                <div class="hm5Arrow"></div>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <el-empty v-else description="暂无内容"></el-empty> -->
                        </div>
                        <div class="hm5Bot gray box3Btn f32 wow fadeInUp">
                            <div class="hm5Item">
                                <div class="hm5Btn flex align-center">
                                    <span class="hmPrev hm5Prev"><i class="el-icon-arrow-left"></i></span>
                                    <span class="hmNext hm5Next"><i class="el-icon-arrow-right"></i></span>
                                </div>
                                <a class="hmMore f18 color_m text-center" href="/news">查看更多 +</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Message></Message>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Message from '@/components/Message.vue'
import Footer from '@/components/Footer.vue'
import Swiper from 'swiper'  // ES引入方式
import { WOW } from 'wowjs'
import home from '@/api/home'
export default {
    name: 'Home',
    components: {
        Header,
        Message,
        Footer
    },
    data() {
        return {
            headType:2,
            banList:[],
            hm2Info:'',
            hm3List:[],
            hm4List:[],
            hm5Index: '',
            hm5Tab:[],
            hm5List:[],
            hm5Lef:0,
        }
    },

    watch: {
        banList(){
            this.$nextTick(()=>{
                new Swiper(".pc-banner", {
                    loop: true,
                    speed:1000,
                    autoplay: {
                        delay: 6000,
                        stopOnLastSlide: false,
                        disableOnInteraction: false,
                    },
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                    parallax : true,
                    watchOverflow: true,
                    resistance: true,
                    resistanceRatio: 0,
                    observer: true,
                    observeParents: true,
                    pagination: {
                        el: '.ban-pagination',
                        clickable :true,
                    }
                });
            })
        }
    },

    created() {
    },
    mounted () {
        this.$nextTick(()=>{
            new WOW({ boxClass:"wow",animateClass:"animated",offset:5,mobile:true,live:false,resetAnimation:true }).init()
            // window.addEventListener('scroll', this.headerMain)
            window.addEventListener('resize', this.getHm5);
            
            new Swiper(".hm3Swiper .swiper-container", {
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
                speed: 1000,
                slidesPerView: 1,
                roundLengths : true,
                watchOverflow: true,
                resistance: true,
                resistanceRatio: 0,
                observer: true,
                observeParents: true,
                centerInsufficientSlides: true,
                slideToClickedSlide: true,
                watchSlidesVisibility: true,
                pagination: {
                    el: '.hm3Swiper .hm-pagination',
                    clickable: true
                },
                breakpoints: {
                    1200: {
                        slidesPerView: 4
                    },
                    991: {
                        slidesPerView: 3
                    },
                    640: {
                        slidesPerView: 2
                    }
                }
            })
            new Swiper('.hm5Swiper .swiper-container',{
                loop: true,
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
                speed: 1000,
                slidesPerView: 1,
                watchOverflow: true,
                resistance: true,
                resistanceRatio: 0,
                observer: true,
                observeParents: true,
                navigation: {
                    prevEl: '.hm5Prev',
                    nextEl: '.hm5Next',
                },
                breakpoints: {
                    1200: {
                        slidesPerView: 2.3
                    },
                    640: {
                        slidesPerView: 2
                    }
                }
            })

            // // 动态内容加载完成后调用 sync 方法，确保在每次动态加载内容后调用 this.$wow.sync() 方法，以便 WOW.js 能够重新扫描页面并为新的 wow 元素添加动画（没起作用）
            // this.$nextTick(() => {
            //   this.$wow.sync();
            // });
            
            const offset = this.getElementOffset(this.$refs.hm5Box);
            this.hm5Lef = offset.left;
        });
        // this.headerMain();
        this.getBanner();
        this.getAbout();
        this.getService();
        this.getCase();
        this.getNews();
    },
    methods: {
        headerMain:function(){
            var headerMain = document.getElementById('header');
            if(window.pageYOffset > 0){
                this.headType = 2;
                headerMain.classList.add('whiterBg');
            }else{
                this.headType = 1;
                headerMain.classList.remove('whiterBg');
            }
        },
        getBanner(){
            home.banner({site:1}).then((res) => {
                if (res.code === 1) {
                    this.banList = res.data;
                } else {
                    this.$toast(res.msg)
                }
            })
        },
        getAbout(){
            home.about().then((res)=>{
                if (res.code === 1) {
                    this.hm2Info = res.data
                } else {
                    this.$toast(res.msg)
                }
            })
        },
        getService(){
            home.serList().then((res)=>{
                if (res.code === 1) {
                    this.hm3List = res.data.rows
                } else {
                    this.$toast(res.msg)
                }
            })
        },
        getCase(){
            home.caseList({page:1,limit:5}).then((res)=>{
                if (res.code === 1) {
                    this.hm4List = res.data.rows;
                } else {
                    this.$toast(res.msg)
                }
            });
        },        
        getNews(){
            home.newsList({page:1,limit:6,t:this.hm5Index}).then((res)=>{
                if (res.code === 1) {
                    this.hm5Tab = res.data.article?Object.entries(res.data.article):'';
                    this.hm5List = res.data.rows;
                    this.total = res.data.total;
                } else {
                    this.$toast(res.msg)
                }
            });
        },


        changeHm5(index){
            this.hm5Index = this.hm5Tab[index][0];
            this.getNews();
        },
        getElementOffset(element) {
            const rect = element.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
            const clientTop = document.documentElement.clientTop || 0;
            const clientLeft = document.documentElement.clientLeft || 0;
            return {
                top: rect.top + scrollTop - clientTop,
                left: rect.left + scrollLeft - clientLeft
            };
        },
        getHm5(){
            const offset = this.getElementOffset(this.$refs.hm5Box);
            this.hm5Lef = offset.left;
        }
    },
    destroyed(){
        // window.removeEventListener('scroll', this.headerMain)
        window.removeEventListener('resize', this.getHm5);
    }
}
</script>

<style lang="scss" scoped>
    @import '@/assets/css/home.scss';
</style>